import SuggestedLessons from './template';
export default SuggestedLessons;
